import React from 'react';
import { MapPin, ArrowRight, Star } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative overflow-hidden hero-gradient">
      <div className="absolute inset-0 opacity-15" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, white 1px, transparent 1px)', backgroundSize: '32px 32px' }} />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/20 px-4 py-1.5 text-sm font-semibold text-white backdrop-blur">
              <Star className="h-4 w-4 fill-white" /> Alle vostre consegne ci pensiamo noi!
            </span>
            <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05]">
              Il tuo cibo preferito,<br /> Consegnato in un Fast.
            </h1>
            <p className="mt-5 max-w-md text-lg text-white/90">
              Pizza, sushi, burger e tanto altro dai migliori ristoranti della tua città. Ordina ora e ricevi a casa in pochi minuti.
            </p>

            <div className="mt-8 flex items-start gap-3 bg-white/15 backdrop-blur border border-white/25 p-4 sm:p-5 rounded-2xl max-w-xl">
              <MapPin className="h-6 w-6 text-white shrink-0 mt-0.5" />
              <p className="text-white text-base sm:text-lg leading-snug">
                <span className="font-semibold">Siamo presenti a</span> Belvedere M.mo, Diamante, Castrovillari, Catanzaro Lido, Sellia M.na, Cropani M.na e Botricello.
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/90">
              <span className="flex items-center gap-2"><ArrowRight className="h-4 w-4" /> Ristoranti selezionati</span>
              <span className="flex items-center gap-2"><ArrowRight className="h-4 w-4" /> Consegna media 30 min</span>
              <span className="flex items-center gap-2"><ArrowRight className="h-4 w-4" /> Pagamenti sicuri</span>
            </div>
          </div>

          <div className="relative hidden lg:block animate-fade-up">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl rotate-1">
              <img
                src="https://images.pexels.com/photos/4393245/pexels-photo-4393245.jpeg?auto=compress&cs=tinysrgb&w=900"
                alt="Rider Italian Fast Delivery"
                className="w-full h-[460px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-4 flex items-center gap-3 -rotate-2">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent">
                <Star className="h-6 w-6 text-primary fill-primary" />
              </div>
              <div>
                <p className="font-display font-bold text-foreground leading-none">4.8 / 5</p>
                <p className="text-sm text-muted-foreground">su +50.000 recensioni</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
